import apiHandler from "./apiHandler";



const apiMetadata = {
  youtube: (url) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/metadata/youtube`, {
          url,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiMetadata;
